import { reactive } from "vue";

export const hash = reactive({
    id: null
})

export const openCategories = reactive({
    x: 0
});